/**
 * Starting an asynchronous call from an effect.
 *
 * @module utils/begin
 */

/**
 * Start an asynchronous call in a continuation and hand back its promise.
 *
 * Two reasons, both about the effect that ends up calling it. A state update
 * reached synchronously from an effect body cascades a render before the first
 * has painted, so the work has to move off that path. And a call that throws
 * synchronously, rather than returning a rejected promise, escapes the effect
 * instead of reaching the chain's own `catch`. An `async` function gave both of
 * those for free; a promise chain does not, and this restores them.
 */
export function begin<T>(call: () => T | Promise<T>): Promise<T> {
  return Promise.resolve().then(call);
}
